import logoPng from '@listening/assets/astro/images/listening-logo.png';
import { createFileRoute, Link } from '@tanstack/react-router';
import { Footer } from '@/components/astro/new-design-25/ui/Footer';
import { localizeHref } from '@/paraglide/runtime';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/delete-data')({
  head: () => ({
    meta: [
      ...seo({
        title: 'Data Deletion Request | Secure Your Privacy with Listening.com',
        description:
          'Take control of your data at Listening.com. Securely request to delete your data and safeguard your privacy. We are committed to responsible information handling.',
      }),
    ],
  }),
  component: () => (
    <>
      <div className='pt-[45px]sm:max-w-[728px] mx-auto mb-[100px] flex h-[90px] max-w-none auto-cols-[1fr] grid-cols-[1fr_1fr] grid-rows-[auto_auto] justify-between gap-4 pb-0 lg:max-w-[90%]'>
        <div className='flex-1 self-center [@media(max-width:767px)]:flex [@media(max-width:767px)]:justify-center'>
          <Link className='inline-block max-w-full' to={localizeHref('/')}>
            <img
              alt='Listening logo'
              className='inline-block h-[40px] sm:block sm:h-[50px] md:h-[40px]'
              loading='lazy'
              src={logoPng}
            />
          </Link>
        </div>
        <div className='hidden items-center md:flex'>
          <a
            className='inline-block max-w-full no-underline'
            href='https://listening.com'
          >
            <div className='mr-[44px] hidden text-[16px] text-neutral-455 sm:block'>
              Product
            </div>
          </a>
          <a
            className='inline-block max-w-full no-underline'
            href='https://listening.com#offer-details'
          >
            <div className='mr-[44px] hidden text-[16px] text-neutral-455 sm:block'>
              Pricing
            </div>
          </a>
          <a
            className='inline-block max-w-full no-underline'
            href='https://listening.com'
          >
            <div className='static flex h-[45px] w-[180px] flex-[0_auto] items-center justify-center rounded-[9px] border border-solid border-azure-245 bg-azure-245 [@media(max-width:767px)]:hidden'>
              <div className='text-[17px] font-[500] text-neutral-140'>
                Listen to Papers
              </div>
            </div>
          </a>
        </div>
      </div>
      <div>
        <h1 className='mt-0 mb-[15px] pr-[39px] pl-[29px] text-center text-[28px] leading-[55px] text-navy-200 sm:mb-[30px] sm:text-[45px] md:px-0 md:leading-[40px]'>
          How to&nbsp;Delete Your&nbsp;Data
          <br />
        </h1>
      </div>
      <div className='ml-[100px] pr-[100px]'>
        <h2 className='mt-0 mb-[15px] pr-[39px] pl-[29px] text-left text-[28px] leading-[55px] text-navy-200 sm:mb-[30px] sm:text-[45px] md:px-0 md:leading-[40px]'>
          1 - How to&nbsp;Delete Your&nbsp;Data
          <br />
        </h2>
        <div className='pr-[122px] text-[16px]'>
          You can delete your account in either the mobile app or the web app.
          <br />
          <br />
          <strong>Mobile App</strong>
          <br />
          <br />
          To delete your data in the mobile app, click "Settings", then scroll
          all the way to the bottom and click "Delete Account".
          <br />
          <br />
          Note that deleting your account will cancel any Stripe subscriptions,
          but it will not automatically cancel Google or Apple subscriptions.
          Subscriptions made through App Stores have to be canceled in their
          respective app stores.
          <br />
          <br />
          <strong>Web Interface</strong>
          <br />
          <br />
          To delete your data from the web app, log in below, then click
          "Settings" and "Delete Account".
          <br />
          <br />
          You can log into your web app account here:
          <Link to={localizeHref('/app/login')}>
            https://www.listening.com/app/login
          </Link>
        </div>
      </div>
      <div className='ml-[100px] pr-[100px]'>
        <h2 className='mt-0 mb-[15px] pr-[39px] pl-[29px] text-left text-[28px] leading-[55px] text-navy-200 sm:mb-[30px] sm:text-[45px] md:px-0 md:leading-[40px]'>
          2 - Contact Us
          <br />
        </h2>
        <div className='pr-[122px] text-[16px]'>
          If you have questions about our data policy, or need help deleting
          your data, please contact us at{' '}
          <a href='mailto:support@listening.com'>support@listening.com</a>
        </div>
      </div>
      <section className='mb-[55px]' />
      <Footer />
    </>
  ),
});
